"use client";

import { AppContainer } from "@/components";
import { cn } from "@/lib";
import useEmblaCarousel from "embla-carousel-react";
import { EmblaOptionsType } from "embla-carousel";
import { useCallback, useEffect } from "react";
import { BdAltArrowLeft, BdAltArrowRight } from "solar-icon-react/bd";
import Link from "next/link";
import { routes } from "@/routes";

export type HomePageBanner = {
  id: number;
  src: string;
  title: string;
  alt: string;
  href: string;
};

const defaultImages: HomePageBanner[] = [
  {
    id: 3,
    src: "/images/novin-payamak.webp",
    title: "ورود به پنل اس ام اس نوین پیامک",
    alt: "ورود به پنل اس ام اس نوین پیامک",
    href: "http://sms.novin.one/",
  },
  {
    id: 2,
    src: "/images/trackingPost.webp",
    title: "رهگیری مرسولات پستی نوین وان",
    alt: "رهگیری مرسولات پستی نوین وان",
    href: routes.services.Postal_Tracking_Inquiry.rewritePath,
  },
  {
    id: 1,
    src: "/images/identification.webp",
    title: "استعلام ثبت احوال با کدملی و تاریخ تولد",
    alt: "استعلام ثبت احوال با کدملی و تاریخ تولد",
    href: routes.services.Identity_Inquiry.rewritePath,
  },
  {
    id: 0,
    src: "/images/fines.webp",
    title: "استعلام و پرداخت خلافی خودرو نوین وان",
    alt: "استعلام و پرداخت خلافی خودرو نوین وان",
    href: routes.services.Fines.rewritePath,
  },
];

const HomeSliderSection = ({ banners }: { banners?: HomePageBanner[] }) => {
  const images = banners?.length ? banners : defaultImages;
  const options: EmblaOptionsType = {
    loop: true,
    containScroll: "trimSnaps",
    align: "start",
    startIndex: 0,
    dragFree: true,
  };
  const [emblaRef, emblaApi] = useEmblaCarousel(options);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);
  // Autoplay functionality
  useEffect(() => {
    if (!emblaApi) return;

    let autoplay: NodeJS.Timeout;

    const startAutoplay = () => {
      autoplay = setInterval(() => {
        emblaApi.scrollNext();
      }, 5000);
    };

    const stopAutoplay = () => {
      if (autoplay) clearInterval(autoplay);
    };

    // Start autoplay
    startAutoplay();

    // Stop autoplay on user interaction
    emblaApi.on("pointerDown", stopAutoplay);

    // Restart autoplay after user stops interacting
    emblaApi.on("settle", () => {
      stopAutoplay();
      startAutoplay();
    });

    return () => {
      stopAutoplay();
      emblaApi.off("pointerDown", stopAutoplay);
    };
  }, [emblaApi]);
  return (
    <>
      <section className="mb-16 w-full overflow-hidden sm:mb-20 lg:mb-30">
        <AppContainer
          className={cn(
            "relative h-auto max-w-[900] md:max-w-[1000px] lg:max-w-[1320px]",
          )}
        >
          <div
            dir="ltr"
            className={cn(
              "m-auto flex w-full items-center justify-center md:px-6",
            )}
          >
            <div className="w-full overflow-hidden" ref={emblaRef}>
              <div className={cn("flex w-full")}>
                {images.map((image) => (
                  <div key={image.id} className="slider-item p-1">
                    <Link href={image.href} title={image.title}>
                      <img
                        src={image.src}
                        alt={image.alt || image.title}
                        title={image.title}
                        style={{
                          objectFit: "contain",
                        }}
                        className="h-auto w-full rounded-md lg:rounded-lg"
                      />
                    </Link>
                  </div>
                ))}
              </div>
            </div>
            <div
              className={cn(
                "absolute top-[45%] hidden w-full justify-between px-8 lg:flex lg:px-0",
              )}
            >
              <button
                className={cn("cursor-pointer")}
                onClick={onPrevButtonClick}
              >
                <BdAltArrowLeft
                  className={cn(
                    "text-primary-main! h-[20px] w-[20px] lg:h-[30px] lg:w-[30px]",
                  )}
                />
              </button>
              <button
                className={cn("cursor-pointer")}
                onClick={onNextButtonClick}
              >
                <BdAltArrowRight
                  className={cn(
                    "text-primary-main! h-[20px] w-[20px] lg:h-[30px] lg:w-[30px]",
                  )}
                />
              </button>
            </div>
          </div>
        </AppContainer>
      </section>
    </>
  );
};

export default HomeSliderSection;
